<template>
  <q-drawer
    v-model="drawer"
    :data-testid="elementsIds.leftDrawer.sideMenuMainContainer"
    side="left"
    :mini-width="72"
    show-if-above
    :mini="miniStateComputed"
    mini-to-overlay
    :width="216"
    :breakpoint="500"
    class="ib-bg-grey-9 incredi-sidemenu column"
    :style="{ borderRight: '1px solid rgb(0 0 0 / 50%) !important' }"
    @mouseover="miniState = false"
    @mouseout="miniState = true"
  >
    <div
      class="ib-logo"
      :class="{ open: !miniStateComputed }"
    ></div>
    <div class="mainMenu ibf-h3">
      <sidemenu-list :mini-state="miniStateComputed" />

      <q-list>
        <user-profile-menu v-model="userMenuOpened">
          <div
            :data-testid="elementsIds.leftDrawer.userProfileMenuItem"
            class="menuItemBackground"
            style="margin-bottom: 12px"
            :class="{ 'menuItemActive ibf-h4': userMenuOpened, wide: !miniStateComputed, mini: miniStateComputed }"
          >
            <q-item
              id="sidebar-help"
              clickable
              class="focus-be-gone"
            >
              <q-item-section avatar>
                <img
                  :src="menuIconUserProfile"
                  alt=""
                />
              </q-item-section>
              <q-item-section>My Profile</q-item-section>
            </q-item>
          </div>
        </user-profile-menu>
        <help-menu v-model="helpMenuOpened">
          <div
            class="menuItemBackground"
            :data-testid="elementsIds.leftDrawer.sideMenuHelpMenuItem"
            style="margin-bottom: 12px"
            :class="{ 'menuItemActive ibf-h4': helpMenuOpened || helpMenuSelected, wide: !miniStateComputed, mini: miniStateComputed }"
          >
            <q-item
              id="sidebar-help"
              clickable
              class="focus-be-gone"
            >
              <q-item-section avatar>
                <img
                  :src="menuIconHelp"
                  alt=""
                />
              </q-item-section>
              <q-item-section>Help</q-item-section>
            </q-item>
          </div>
        </help-menu>
      </q-list>
    </div>
  </q-drawer>
</template>
<script>
import elementsIds from '@/const/elementIds.json';
import { dialogPresets } from '@/services/dialogPresets';
import { dialogMixins } from '@/components/common/dialogs/dialogMixins';
import { defineComponent, inject, ref } from 'vue';
import HelpMenu from '@/components/common/helpMenu.vue';
import userProfileMenu from '@/components/common/userProfileMenu.vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import nav_user_info_profile_selected from '@/assets/images/icons/sideMenuIcons/nav_user_info_profile_selected.svg';
import nav_user_info_profile from '@/assets/images/icons/sideMenuIcons/nav_user_info_profile.svg';
import nav_icon_help_selected from '@/assets/images/icons/sideMenuIcons/nav_help_selected.svg';
import nav_icon_help from '@/assets/images/icons/sideMenuIcons/nav_help.svg';
import { useRoute } from 'vue-router';
import { Routes } from '@/router/router.const';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import sidemenuList from './components/sidemenu-list/sidemenu-list.vue';

export default defineComponent({
  name: 'LayoutDefault',
  components: { HelpMenu, userProfileMenu, sidemenuList },
  mixins: [dialogMixins, dialogPresets],
  setup() {
    const userRolePermissions = useUserRolePermissions();
    const helpMenuOpened = ref(false);
    const userMenuOpened = ref(false);
    const route = useRoute();

    const coordinatorService = inject(IKCoordinatorsService);
    const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorService?.selectedCoordinator.value || '' }));

    return { userRolePermissions, helpMenuOpened, userMenuOpened, elementsIds, route, GQL_commonData };
  },
  data() {
    return {
      drawer: false,
      miniState: true,
      notMinistate: null,
    };
  },
  computed: {
    miniStateComputed() {
      if (this.helpMenuOpened) return false;
      if (this.userMenuOpened) return false;
      if (this.$store.getters['agents/getAgentBulkMenuVisible']) return true;
      return this.miniState;
    },
    helpMenuSelected() {
      return this.GQL_commonData?.result?.value?.ibManagerEntities?.license?.windows?.isFreeDev && this.route.name === Routes.GettingStarted;
    },
    menuIconUserProfile() {
      return this.userMenuOpened ? nav_user_info_profile_selected : nav_user_info_profile;
    },
    menuIconHelp() {
      return this.helpMenuOpened || this.helpMenuSelected ? nav_icon_help_selected : nav_icon_help;
    },
  },
  mounted() {
    this.notMinistate = !this.miniState;
  },
  methods: {},
});
</script>

<style lang="scss" scoped>
.sidebar-logout {
  padding: 8px !important;
  i.icon-more-horizontal {
    color: $-dark--theme--text-light-text-primary;
  }
}

:deep(.q-item__section--side) {
  padding-right: 12px;
  min-width: unset;
}
:deep(.q-item__section--main) {
  min-width: 95px;
}
:deep(.sidemenu-logout-container) {
  padding: 12px;
  display: flex;
  align-items: flex-end;

  width: 100% !important;
  min-width: 100%;
  &.mini {
    justify-content: center;
  }
  .sidebar-logout {
    height: 100%;
  }
  &:hover {
    transition: background 0.2s;
    background: $-text--dark !important;
  }
}
:deep(.incredi-sidemenu) {
  flex-wrap: nowrap;
  overflow: hidden;
  overflow-y: auto;
  min-height: 468px;
  .absolute.full-width {
    height: 100%;
    flex-direction: column;
    display: flex;
  }
}
.backup-coordinator-label {
  position: absolute;
  top: 50%;
  left: 0;
  margin-left: -60px;

  transform: rotate(-90deg);
  width: 180px;
  text-align: center;
  & .text {
    margin-left: 10px;
  }
  & .icon {
    font-size: 24px;
  }
}
.padding-top-10 {
  padding-top: 10px;
}
.action-user-menu {
  //font-family: Gordita-Regular;
  //font-size: 11px;
  line-height: 27px;
  /* AppColores_Brand almost black */
  width: 210px;
  height: 68px;
  display: block;
  &.close {
    display: none;
  }
  .action-user-menu-item {
    overflow: hidden;
    //color: #FFFFFF;
    background: #000000;
    //font-size: 11px;
    width: 100%;
    height: 100%;
    .menu-item-row {
      width: 100%;
      height: 52px;
      padding-left: 16px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
.ib-logo {
  width: 100%;
  padding-bottom: 80px;
  background: #1b1b1b url('@/assets/images/ibx-logo-black.png') no-repeat top;
  background-position-x: 0;
  background-size: 284px;

  &.open {
    width: 100%;
    background-position-x: -72px;
    background-size: 284px;
  }
}

.content-layout {
  display: flex;
  flex-direction: row;
  background: $-system-app-background !important;
}

.closed {
  width: 0 !important;
  border-width: 0;
  /*transition: width 1.5s cubic-bezier(0.820, 0.085, 0.395, 0.895);*/
}
@keyframes side-menu-item-animation {
  0% {
    opacity: 1;
  }
  10% {
    opacity: 0;
  }

  60% {
    opacity: 1;
  }
}

:deep(.menuItemBackground) {
  overflow: hidden;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-left: 0;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 24px;
  border-radius: 50px;

  &.mini {
    height: 48px;
    width: 48px;

    :deep(.q-item) {
      animation-name: side-menu-item-animation;
      animation-duration: 1s;
    }

    &.menuItemActive {
      background: $-text--dark !important;
      border: 0 solid #60ecb8;
      color: $-text--dark;

      .q-icon {
        &::before {
          color: $-text--dark;
        }
      }
    }

    &:hover:not(.menuItemActive) {
      transition: background 0.2s;
      background: $-hovers-hover-grey;
    }
  }

  .q-item {
    padding: 8px !important;
  }

  &.wide {
    width: 192px;
    border-radius: 50px;
    align-items: center;
    justify-content: left;

    &.menuItemActive {
      background: $-text--dark !important;
      color: $-dark--theme--text-light-text-primary;

      .q-icon {
        &::before {
          color: $-text--dark;
        }
      }
    }

    &:hover:not(.menuItemActive) {
      transition: background 0.2s;
      background: $-hovers-hover-grey;
    }

    .q-item {
      background: rgba(0, 0, 0, 0);
      min-width: 100%;

      .q-item-section {
        color: #505050;
      }
    }
  }
}
.mainMenu {
  display: flex;
  padding-top: 24px;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: 1;
}
</style>
